import React, { useState, useEffect } from 'react';
import { Box, Icon, Image, Flex, Text, Tooltip, IconButton } from '@chakra-ui/react'

import { FiPackage, FiImage } from "react-icons/fi";
import BaseModal from '../GlobalComponents/BaseModal';

export default function HistoryBox(props) {
    const [liveImage, setLiveImage] = useState('');
    useEffect(() => {
        setfirstImage(props.image);
    }, [props.isOpen])

    function setfirstImage() {

        if (props.isOpen && Array.isArray(props.History) && props.History[0]?.ImageUri) {
            setLiveImage(props.History[0].Manifest + '/' + props.History[0].ImageUri)
        }
    }

    return (
        <BaseModal isOpen={props.isOpen} onClose={() => [setLiveImage(''), props.paketCall()]} style={{ display: 'flex', alignItems: 'center', flexDirection: 'column', minWidth: '750px', height: '500px' }}>

            <Text fontSize={25} fontWeight='bold' style={{ margin: 5 }}>Paketnummer: {props.curentPaket}</Text>
            <Flex style={{ flex: 1, width: '100%', maxHeight: '100%', flexDirection: 'row', margin: 3, padding: 3, overflow: 'auto' }}>
                <Flex style={{ flex: 1.2, margin: 5, alignItems: 'center', justifyContent: 'center' }}>

                    {liveImage !== null && liveImage !== '' ? (
                        <a
                            style={{ display: 'flex', width: '100%', height: '100%' }}
                            href={props.server + '/API/' + props.ImageDir + liveImage} target="_blank"
                        >
                            <Image
                                src={props.server + '/API/' + props.ImageDir + liveImage}
                                alt={props.server + '/API/' + props.ImageDir + liveImage}
                                key={liveImage} objectFit='contain'
                                style={{ width: '100%', maxWidth: '100%', maxHeight: '100%', boxSizing: 'border-box' }}
                            />
                        </a>
                    ) : (
                        <Icon as={FiPackage} color='#aaa' boxSize={150} />
                    )}

                </Flex>
                <Flex style={{ flex: 2, flexDirection: 'column', margin: 5, overflow: 'auto' }}>

                    {props.History.map((item) => {

                        return (
                            <Flex display='flex' flexDir='row' justifyContent='space-between' alignItems='center' bg='#ddd' key={item.ID} minWidth='380px' mb={1} px={1}>
                                <Box>
                                    <Text fontWeight='bold'>{item.Änderungsdatum}</Text>
                                    <Text>Manifest: {item.Manifest} | {item.Status} | {item.Zustell_Status}</Text>
                                </Box>
                                {item.ImageUri ? (
                                    <Tooltip label={item.ImageUri} placement='top' hasArrow bg='#666'>
                                        <IconButton bg='#1DA1F2' color='#fff' width='40px' height='40px' ml='2px' borderRadius="7px"
                                            onClick={() => setLiveImage(item.Manifest + '/' + item.ImageUri)}
                                            icon={<Icon as={FiImage} color='#fff' boxSize={30} />} />
                                    </Tooltip>
                                ) : (null)}
                            </Flex>
                        );

                    })}

                </Flex>
            </Flex>
        </BaseModal>
    );
}